(()=>{
'use strict';
if(window.__senfinecoExactYearLoader)return;window.__senfinecoExactYearLoader=true;

const SF_YEAR_FIELD_INDEX=2;
const SF_RANGE_DASHES=/[\u2010-\u2015\u2212]/g;
const SF_BAD_AVALON_HYBRID_TARGET='toyota-avalon-2005-2006-v6-3-5l-petrol-esi6435382';

function installNativeExactYears(){
  const es=window.easysearch;
  if(!es||es.__senfinecoNativeExactYears)return;
  es.__senfinecoNativeExactYears=true;

  const originalChunkHandler=es._papaparseChunkHandler;
  if(typeof originalChunkHandler==='function'){
    es._papaparseChunkHandler=function(chunk,rangedField){
      if(chunk&&Array.isArray(chunk.data)){
        chunk.data=chunk.data.filter(function(row){
          if(Array.isArray(row)&&typeof row[SF_YEAR_FIELD_INDEX]==='string'){
            row[SF_YEAR_FIELD_INDEX]=row[SF_YEAR_FIELD_INDEX]
              .replace(SF_RANGE_DASHES,'-')
              .replace(/\s*-\s*/g,'-')
              .trim();

            const isBrokenAvalonHybrid=
              String(row[0]||'').trim().toLowerCase()==='toyota'&&
              String(row[1]||'').trim().toLowerCase()==='avalon'&&
              row[SF_YEAR_FIELD_INDEX]==='2019-2022'&&
              /hybrid/i.test(String(row[3]||''))&&
              String(row[4]||'').includes(SF_BAD_AVALON_HYBRID_TARGET);
            if(isBrokenAvalonHybrid)return false;
          }
          return true;
        });
      }
      return originalChunkHandler.call(this,chunk,rangedField);
    };
  }

  function setRangedYearField(){
    if(es.settings&&es.settings.form&&!(es.eventStates&&es.eventStates.easysearch_tree_inited)){
      es.settings.form.ranged_field=SF_YEAR_FIELD_INDEX;
    }
  }

  document.addEventListener('easysearch_settings_inited',setRangedYearField,{once:true});
  setRangedYearField();
}

document.addEventListener('easysearch_before_ready',installNativeExactYears,{once:true});
if(window.easysearch)installNativeExactYears();

function installExactYearMemory(){
  if(window.__senfinecoExactYearMemory)return;
  window.__senfinecoExactYearMemory=true;

  function normalizeDigits(value){
    return String(value||'')
      .replace(/[\u0660-\u0669]/g,function(digit){return String(digit.charCodeAt(0)-0x0660);})
      .replace(/[\u06f0-\u06f9]/g,function(digit){return String(digit.charCodeAt(0)-0x06f0);});
  }

  document.addEventListener('change',function(event){
    const select=event.target;
    if(!(select instanceof HTMLSelectElement))return;

    const holder=select.closest('.easysearch-select-holder');
    const label=holder&&holder.querySelector('label');
    const placeholder=select.querySelector('option[value=""]');
    const labelText=((label&&label.textContent)||'')+' '+((placeholder&&placeholder.textContent)||'');
    const isYear=select.getAttribute('data-sort-order')==='2'||/(?:^|\s)(?:year|السنة|السنه)(?:\s|$)/i.test(labelText.trim());
    if(!isYear)return;

    const selected=select.options[select.selectedIndex];
    const match=normalizeDigits((selected&&selected.textContent)||select.value).trim().match(/^((?:19|20)\d{2})$/);
    if(!match)return;

    const root=select.closest('.easysearch-widget, .easysearch-main-widget, form')||select.parentElement;
    if(!root)return;
    const selects=Array.from(root.querySelectorAll('select')).filter(function(item){
      return item.getAttribute('data-sort-order')!==null;
    });
    const make=selects[0]&&selects[0].value;
    const model=selects[1]&&selects[1].value;
    if(!make||!model)return;

    const saved=JSON.stringify({
      version:1,
      make:String(make),
      model:String(model),
      range:'',
      year:match[1],
      savedAt:Date.now()
    });
    try{window.sessionStorage.setItem('sfYmmExactYearV1',saved);}catch(_sessionError){}
    try{window.localStorage.setItem('sfYmmExactYearV1',saved);}catch(_localError){}
  },true);
}
installExactYearMemory();

const src=document.currentScript?.src;if(!src)return;
const files=['senfineco-gulf-vehicle-catalog.js','senfineco-exact-year-core.js','sf-oil-drive-core.js','sf-oil-drive-render.js','sf-oil-diff-patch.js','sf-oil-toyota-at-data.js','sf-oil-lexus-at-data.js','sf-oil-toyota-lexus-at.js','sf-oil-toyota-lexus-at-style.js','sf-oil-drive-boot.js','senfineco-brake-fluid-fix.js'];
const BUILD='20260825-native-exact-years-v3';const assetURL=(file)=>{const url=new URL(file,src);url.searchParams.set('sfv',BUILD);return url.href};let i=0;const next=()=>{if(i>=files.length)return;const f=files[i++],s=document.createElement('script');s.src=assetURL(f);s.async=false;s.dataset.sfLoaderAsset=f;s.onload=next;s.onerror=()=>console.error('[SENFINECO] Could not load '+f);document.head.appendChild(s)};next();
})();
